export const styles = {
  wrap: 'px-0.5 mb-3',
  runningExpanded:
    'w-full rounded-lg bg-gradient-to-br from-purple-50/80 to-pink-50/80 backdrop-blur-sm ' +
    'border border-purple-200/50 hover:border-purple-300 transition-colors cursor-pointer ' +
    'px-3 py-2.5 text-left',
  runningCollapsed:
    'flex flex-col items-center justify-center gap-1 w-full aspect-square rounded-lg ' +
    'bg-gradient-to-br from-purple-50/80 to-pink-50/80 backdrop-blur-sm ' +
    'border border-purple-200/50 hover:border-purple-300 transition-colors cursor-pointer',
  failedExpanded:
    'w-full rounded-lg bg-gradient-to-br from-red-50/80 to-orange-50/80 backdrop-blur-sm ' +
    'border border-red-200/60 hover:border-red-300 transition-colors cursor-pointer ' +
    'px-3 py-2.5 text-left',
  failedCollapsed:
    'flex items-center justify-center w-full aspect-square rounded-lg ' +
    'bg-gradient-to-br from-red-50/80 to-orange-50/80 backdrop-blur-sm ' +
    'border border-red-200/60 hover:border-red-300 transition-colors cursor-pointer',
  idleExpanded:
    'w-full rounded-lg bg-gradient-to-br from-amber-50/80 to-orange-50/80 backdrop-blur-sm ' +
    'border border-amber-200/50 hover:border-amber-300 transition-colors cursor-pointer ' +
    'px-3 py-2.5 text-left',
  idleCollapsed:
    'flex items-center justify-center w-full aspect-square rounded-lg ' +
    'bg-gradient-to-br from-amber-50/80 to-orange-50/80 backdrop-blur-sm ' +
    'border border-amber-200/50 hover:border-amber-300 transition-colors cursor-pointer',
  stageLabel: 'text-xs font-medium text-purple-700 truncate',
  failedLabel: 'text-xs font-medium text-red-700 truncate',
  idleLabel: 'text-xs font-medium text-amber-700 truncate',
  percent: 'ml-auto shrink-0 text-xs font-medium tabular-nums text-purple-700',
  percentCollapsed: 'text-[10px] font-medium tabular-nums leading-none text-purple-700',
  meter: 'mt-2 h-1',
} as const;
